export default "__VITE_ASSET__19b4452d__"